import axios from "axios";
import { errorToaster } from "./toaster";
import https from "https";

const agent = new https.Agent({
    rejectUnauthorized: false, // Disable SSL verification
});

const apiCall = async (method, url, data = null, options = {}) => {
    try {
        // Merge options with the custom HTTPS agent
        const requestOptions = {
            ...options,
            httpsAgent: agent, // 🔹 Attach the custom SSL agent
        };
        const response =
            method === "get" || method === "delete"
                ? await axios[method](url, requestOptions)
                : await axios[method](url, data, requestOptions);
        return response.data; // Extract the data directly from the response
    } catch (err) {
        handleError(err);
        throw err;
    }
};

const handleError = (err) => {
    const message = err?.response?.data?.msg || "Something went wrong!";
    if (typeof window !== "undefined") { // Ensure it's client-side
        console.log(message);
        errorToaster(message);
    } else {
        console.error("Error (server-side):", err);
        console.log(message);
    }
};

export const getAPICall = (url, options = {}) => apiCall("get", url, null, options);
export const postAPICall = (url, details, options = {}) => apiCall("post", url, details, options);
export const putAPICall = (url, data, options = {}) => apiCall("put", url, data, options);
export const deleteAPICall = (url, options = {}) => apiCall("delete", url, null, options);